import { ACCOUNT_CHANGE_EVENT_NAME } from "../../../../javascript/utils";

interface Props {
  hydrate_article_url: string;
  container_element: Element;
}

interface Response {
  body: string;
}

const init = async (props: Props) => {
  fetchData(props);
  window.addEventListener(ACCOUNT_CHANGE_EVENT_NAME, () => fetchData(props));
}

const fetchData = async (props: Props) => {
  const response = await fetch(props.hydrate_article_url);

  if (response.ok) {
    const json = await response.json() as Response;
    const element = props.container_element.querySelector('.syndicated-article-body');
    element.innerHTML = json.body;
  } else {
    throw new Error("AboutArticle: something went wrong when fetching dynamic content");
  }
}

export const SyndicatedArticle = {
  init,
};
